export const isAuthenticated = (state) => {
    return state.user.token !== ""
}
export const getToken = (state) => {
    return state.user.token;
}

export const getBaseURL = (state) => {
    return state.baseURL;
}

export const getVersion = (state) => {
  return state.version;
}

export const getUser = (state) => {
    return state.user;
}

export const getCompanyURL = (state) => {
  return state.companyUrl;
}
export const getCompanyName = (state) => {
  return state.companyName;
}

export const getRequiredFields = (state) => {
  return state.requiredFields;
}

export const getAuthority = (state) => {
    return state.authMap;
}

export const getAuthCanliIzleme = (state) => {
    return state.authMap.canliIzleme;
}

export const getAuthKisiler = (state) => {
    return state.authMap.kisiler;
}

export const getAuthGecisYetkileri = (state) => {
    return state.authMap.gecisYetkileri;
}

export const getAuthRaporlar = (state) => {
    return state.authMap.raporlar;
}

export const getAuthAyarlar = (state) => {
    return state.authMap.ayarlar;
}

export const getAuthTanimlamalar = (state) => {
    return state.authMap.tanimlamalar;
}
export const getAuthBekciTur = (state) => {
    return state.authMap.bekciTur;
}

export const getModules = (state) => {
  return state.modules;
}

export const getDefaultFilters = (state) => {
  return state.defaultFilters;
}

export const getBuildings = (state) => {
  return state.buildings;
}



// WEBPACK FOOTER //
// ./src/store/getters.js